export default "__VITE_ASSET__a5916ed7__"